import React from "react";
import { ExternalLink, DollarSign } from "lucide-react";
import { bookingUrl, googleFlightsUrl } from "../data/mock";
import { api } from "../lib/api";

// Outbound links: book the award on the airline site, or compare cash fares on Google Flights.
export default function BookButtons({ deal, size = "sm", source = "card" }) {
  const big = size === "lg";
  const track = (target) => () => api.trackBookClick(deal, target, source);
  return (
    <div className={`flex ${big ? "flex-col gap-2 sm:flex-row sm:items-center" : "flex-col gap-1.5"}`}>
      <a
        href={bookingUrl(deal)}
        target="_blank"
        rel="noopener noreferrer nofollow"
        onClick={track("airline")}
        data-testid="book-on-airline-link"
        className={`inline-flex items-center justify-center gap-1.5 rounded-lg bg-slate-900 font-semibold text-white transition-colors hover:bg-blue-600 ${big ? "h-11 px-5 text-sm" : "h-10 px-3 text-xs"}`}
      >
        Book on {deal.program} <ExternalLink className={big ? "h-4 w-4" : "h-3.5 w-3.5"} />
      </a>
      <a
        href={googleFlightsUrl(deal)}
        target="_blank"
        rel="noopener noreferrer nofollow"
        onClick={track("google_flights")}
        data-testid="google-flights-link"
        className={`inline-flex items-center justify-center gap-1 font-medium text-slate-500 transition-colors hover:text-blue-600 ${big ? "h-11 px-3 text-sm" : "min-h-8 text-[11px]"}`}
      >
        <DollarSign className="h-3.5 w-3.5" /> Compare cash on Google Flights
      </a>
    </div>
  );
}
